import { render, staticRenderFns } from "./CPTemp9.vue?vue&type=template&id=64b0198b&scoped=true&"
import script from "./CPTemp9.vue?vue&type=script&lang=js&"
export * from "./CPTemp9.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp9.vue?vue&type=style&index=0&id=64b0198b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0198b",
  null
  
)

export default component.exports